import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListCouponCodesBySubscriber from '../../components/coupon-codes/subscriber-coupon-code.component';

const SubscriberPromocodeView = () => {
  const pageTitle = 'Analytics / Promo Code Usage';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListCouponCodesBySubscriber />
    </AppLayout>
  );
};

export default SubscriberPromocodeView;
